// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eCqvX","controls":"styles_controls__f0io8","charLimit":"styles_charLimit__3-tJi","input":"styles_input__2b_is","send":"styles_send__eXSM4"};